import React, { useState } from 'react';
import MockPhone from '../assets/mock-phone.png';

interface IDataItem {
  id: number;
  img: string;
}

const data: IDataItem[] = [
  {
    id: 0,
    img: MockPhone
  }
];

export default function HowItWorkImageAnimate() {
  const [activeID, setActiveID] = useState<number>(0);
  const [wrapperStyle, setWrapperStyle] = useState<React.CSSProperties>({
    backgroundImage: `url('${data[0].img}')`
  });

  const handleClick = (id: number) => {
    if (id !== activeID) {
      setActiveID(id);
      setWrapperStyle({
        backgroundImage: `url('${data[id].img}')`
      });
    } else {
      return;
    }
  };

  return (
    <div className="flex">
      <div className="relative -left-10 top-44 flex flex-col ">
        {data.map(item => (
          <div
            key={item.id}
            className={`m-2 h-3 w-3 cursor-pointer rounded-full bg-[#5C6B7E] hover:bg-[#F15A24] ${
              activeID === item.id ? 'bg-orange-600 opacity-90' : ''
            }`}
            onClick={() => handleClick(item.id)}
          />
        ))}
      </div>
      <section
        className="wrapper-transition absolute left-5 top-0 h-[40rem] w-[10rem] bg-contain bg-no-repeat xsm350:w-[10rem] md:w-[30rem]"
        style={wrapperStyle}
      />
    </div>
  );
}
